import { Button, Input } from '@cian/ui-kit';
import * as React from 'react';

import { ModalConfirm } from '../../ModalConfirm';

interface IProps {
  isVisible: boolean;
  name: string;
  onConfirm(name: string): void;
  onCancel(): void;
}

export function ModalRename({ isVisible, name, onConfirm, onCancel }: IProps) {
  const [newName, setNewName] = React.useState(name);

  return (
    <ModalConfirm
      text="Переименовать подборку"
      onClose={onCancel}
      isVisible={isVisible}
      footer={
        <>
          <Button theme="fill_white_primary" size="XS" onClick={onCancel}>
            Отменить
          </Button>
          <Button disabled={!newName || newName === name} size="XS" onClick={() => onConfirm(newName)}>
            Сохранить
          </Button>
        </>
      }
    >
      <Input
        placeholder="Название подборки"
        maxLength={150}
        value={newName}
        onChange={e => setNewName(e.target.value)}
      />
    </ModalConfirm>
  );
}
